"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Review = void 0;

var _react = _interopRequireDefault(require("react"));

var _ = require("../../..");

var _reactRouter = require("react-router");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Helpers
function formatTime(time) {
  var min = Math.floor(time / 60);
  var sec = Math.floor(time - min * 60);

  if (min < 10) {
    min = "0" + min;
  }

  if (sec < 10) {
    sec = "0" + sec;
  }

  return "".concat(min, ":").concat(sec);
} // Review


var Review = function Review(_ref) {
  var updates = _ref.updates,
      csp = _ref.csp,
      onCSPChange = _ref.onCSPChange,
      fullGameMoment = _ref.fullGameMoment;
  var location = (0, _reactRouter.useLocation)(); // Determine whether to show "advanced" CSP editor toosl

  var showCSPTools = location.pathname.includes("advanced");
  var momentDuration = updates.stopAtRelative - updates.startAtRelative; // For review

  var reviewLocation = "none";
  var tags = [];

  if (updates) {
    tags = updates.tags;
  }

  var _iterator = _createForOfIteratorHelper(tags),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var tag = _step.value;

      if (tag.category === "Location" && tag.selected === true) {
        reviewLocation = tag.editor && tag.editor.title ? tag.editor.title : tag.title;
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var reviewPlayers = "";

  var _iterator2 = _createForOfIteratorHelper(tags),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var _tag = _step2.value;

      if (_tag.category === "Players" && _tag.selected === true) {
        var title = _tag.editor && _tag.editor.title ? _tag.editor.title : _tag.title;
        var pre = reviewPlayers.length === 0 ? "" : ", ";
        reviewPlayers += pre + title;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  if (reviewPlayers === "") {
    reviewPlayers = "No players selected";
  }

  var offsetStartAtRelative = fullGameMoment && fullGameMoment.time ? fullGameMoment.time + updates.startAtRelative : updates.startAtRelative;
  return /*#__PURE__*/_react.default.createElement(_.Row, {
    margin: "8 0",
    justifyContent: "flex-start",
    alignItems: "center",
    padding: "0 6",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_.Row, {
    marginBottom: "4",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    span: "3"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    content: "Highlight:",
    marginRight: "2"
  })), /*#__PURE__*/_react.default.createElement(_.Column, {
    span: "9"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    content: "Start: ".concat(formatTime(offsetStartAtRelative))
  }), /*#__PURE__*/_react.default.createElement(_.Label, {
    content: "Length: ".concat(Math.floor(momentDuration), "s")
  }))), /*#__PURE__*/_react.default.createElement(_.Row, {
    marginBottom: "4",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    span: "3"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    content: "Location:",
    marginRight: "2"
  })), /*#__PURE__*/_react.default.createElement(_.Column, {
    span: "9"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    content: reviewLocation
  }))), /*#__PURE__*/_react.default.createElement(_.Row, {
    marginBottom: "4",
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    span: "3"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    content: "Players:",
    marginRight: "2"
  })), /*#__PURE__*/_react.default.createElement(_.Column, {
    span: "9"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    content: reviewPlayers
  }))), showCSPTools && /*#__PURE__*/_react.default.createElement(_.Row, {
    marginBottom: "4"
  }, /*#__PURE__*/_react.default.createElement(_.Column, {
    span: "3"
  }, /*#__PURE__*/_react.default.createElement(_.Label, {
    bold: true,
    content: "Client Side Panning:"
  })), /*#__PURE__*/_react.default.createElement(_.Column, {
    span: "9"
  }, /*#__PURE__*/_react.default.createElement("textarea", {
    value: csp,
    onChange: onCSPChange
  }))));
};

exports.Review = Review;